export default [
  {
    path: '/project/:alias/:projectAlias/ci-cd',
    component: () => import('./pages/ci-cd.layout.vue'),
    children: [
      {
        path: '',
        name: 'pipelines',
        component: () => import('./pages/page-ci-cd-pipelines.vue')
      },
      {
        path: 'job',
        name: 'ci-jobs',
        component: () => import('./pages/page-ci-cd-jobs.vue')
      },
      {
        path: 'schedule',
        component: () => import('./pages/pipelines-schedule-layout.vue'),
        children: [
          {
            path: '',
            name: 'pipelines-schedule',
            component: () => import('./pages/page-ci-cd-pipelines-schedules.vue')
          },
          {
            path: 'create',
            name: 'schedule-create',
            component: () => import('./pages/page-ci-cd-pipeline-schedule-create.vue')
          },
          {
            path: 'edit/:uuid',
            name: 'schedule-edit',
            props: true,
            component: () => import('./pages/page-ci-cd-pipeline-schedule-edit.vue')
          }
        ]
      },
      {
        path: 'templates',
        name: 'pipeline-templates',
        component: () => import('./pages/page-ci-cd-templates.vue')
      },
      {
        path: 'templates/edit',
        name: 'pipeline-template-edit',
        component: () => import('./pages/page-ci-cd-template-edit.vue')
      },
      {
        path: 'pipeline/create',
        name: 'create-pipelines',
        component: () => import('./pages/page-ci-cd-pipeline-create.vue')
      }
    ]
  },
  {
    path: '/project/:alias/:projectAlias/ci-cd/pipeline/:id',
    component: () => import('./pages/page-ci-cd-pipeline.vue'),
    children: [
      {
        name: 'ci-pipeline',
        path: '',
        // eslint-disable-next-line import/no-unresolved
        component: () => import('./pages/page-ci-cd-pipeline-details')
      },
      {
        name: 'ci-pipeline-needs',
        path: 'needs',
        // eslint-disable-next-line import/no-unresolved
        component: () => import('./pages/page-ci-cd-pipeline-needs')
      },
      {
        name: 'ci-pipeline-jobs',
        path: 'jobs',
        // eslint-disable-next-line import/no-unresolved
        component: () => import('./pages/page-ci-cd-pipeline-jobs')
      },
      {
        name: 'ci-pipeline-failed-jobs',
        path: 'failed-jobs',
        // eslint-disable-next-line import/no-unresolved
        component: () => import('./pages/page-ci-cd-pipeline-failed-jobs')
      },
      {
        name: 'ci-pipeline-artifacts',
        path: 'artifacts',
        // eslint-disable-next-line import/no-unresolved
        component: () => import('./pages/page-ci-cd-pipeline-artifacts')
      },
      {
        name: 'ci-pipeline-vulnerabilities',
        path: 'vulnerabilities',
        // eslint-disable-next-line import/no-unresolved
        component: () => import('./pages/ci-pipeline-vulnerabilities'),
        children: [
          {
            path: 'vulnerability-occurrence/:id',
            component: () => import('@/shared-modules/modules/security/pages/vulnerability')
          }
        ]
      }
    ]
  },
  {
    path: '/project/:alias/:projectAlias/ci-cd/job/:id',
    component: () => import('./pages/page-ci-cd-job-layout.vue'),
    children: [
      // eslint-disable-next-line import/no-unresolved
      { path: '', name: 'ci-job', component: () => import('./pages/page-ci-cd-job-info') },
      {
        path: 'artifacts',
        name: 'ci-job-artifacts',
        // eslint-disable-next-line import/no-unresolved
        component: () => import('./pages/page-ci-cd-job-artifacts')
      }
    ]
  }
];
